import React from 'react';

import GlobalParamsButtons from './GlobalParamsButtons';

export const Panel = ({ id, className, border, nopad, children }) => {
    const baseClassName = 'cc-panel';
    className = className ? `${baseClassName} ${className}` : baseClassName;
    if (border) {
        className += ' cc-panel-border';
    }
    if (nopad) {
        className += ' cc-panel-nopad';
    }
    return (
        <div id={id} className={className}>
            {children}
        </div>
    );
};

export const PanelTop = ({ id, className, title, textCenter, buttons, color, children }) => {
    const baseClassName = 'cc-panel-top';
    className = className ? `${baseClassName} ${className}` : baseClassName;
    if (title) {
        title = <h1>{title}</h1>;
    }
    if (textCenter) {
        className += ' cc-text-center';
    }
    if (buttons) {
        buttons = <GlobalParamsButtons />;
    }
    if (color) {
        className += ' cc-panel-top-color';
    }
    return (
        <div id={id} className={className}>
            {title}
            {buttons}
            {children}
        </div>
    );
};

export const PanelBody = ({ id, textCenter, children }) => {
    let className = 'cc-panel-body';
    if (textCenter) {
        className += ' cc-text-center';
    }
    return (
        <div id={id} className={className}>
            {children}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/Panel.jsx